import { Span } from "@tblabs/truffle";
import { Product } from "../../../Models/Product/Product";
import { Box } from "./Box";


export class ProductFeatures extends Box
{
    constructor(product: Product)
    {
        super("product__features", [
            ...product.Features.value.split("\n")
                .flatMap(feature => new Box("product__feature", [
                    new Span("✓").Class("product__feature-icon"),
                    new Span(feature).Class("product__feature-text")
                ])),
        ]);
    }
}
